import React from 'react';
import { Button } from 'antd';
import * as Styles from './styled';

interface FunnelTooltipProps {
  type: 'conversion' | 'dropoff';
  data?: {
    value: string;
    label: string;
  }[];
  onViewGapsClick?: () => void;
}

const FunnelTooltip = ({ type, data, onViewGapsClick, ...p }: FunnelTooltipProps) => {
  return (
    <Styles.TooltipContainer {...p}>
      {data?.map(({ value, label }) => (
        <Styles.MetricRow key={label}>
          <Styles.MetricLabel>
            {label} {type === 'dropoff' && '(drop-off)'}
          </Styles.MetricLabel>
          <Styles.MetricValue>{value}</Styles.MetricValue>
        </Styles.MetricRow>
      ))}

      {type === 'dropoff' && <Button onClick={onViewGapsClick}>View Gaps & Opportunities</Button>}
    </Styles.TooltipContainer>
  );
};

export default FunnelTooltip;
